export const CART_PRODUCTS_REQUEST = "CART_PRODUCTS_REQUEST"
export const CART_PRODUCTS_SUCCESS = "CART_PRODUCTS_SUCCESS"
export const CART_PRODUCTS_FAILURE = "CART_PRODUCTS_FAILURE"

export const UPDATED_CART_REQUEST = "UPDATED_CART_REQUEST"
export const UPDATED_CART_SUCCESS = "UPDATED_CART_SUCCESS"
export const UPDATED_CART_FAILURE = "UPDATED_CART_FAILURE"

export const GET_INITIAL_CART_REQUEST = "GET_INITIAL_CART_REQUEST"
export const GET_INITIAL_CART_SUCCESS = "GET_INITIAL_CART_SUCCESS"
export const GET_INITIAL_CART_FAILURE = "GET_INITIAL_CART_FAILURE"

export const POST_CART_ITEMS_REQUEST = "POST_CART_ITEMS_REQUEST"
export const POST_CART_ITEMS_SUCCESS = "POST_CART_ITEMS_SUCCESS"
export const POST_CART_ITEMS_FAILURE = "POST_CART_ITEMS_FAILURE"

